import axios from 'axios';
import auth from './auth';
import common from "../functions/general";

// DEV
// //const BASE_URL = "http://localhost:7901/api_v1/";
// // const BASE_URL = "http://192.168.22.227:7901/api_v1/";
// // const form_url = "http://192.168.22.227:5650/api/exe_aql";
// // const form_ip = "http://192.168.22.227:5650/form?form_id=";
// PROD
// // const BASE_URL = "http://192.168.22.227:8901/api_v1/";
// const form_url = "http://192.168.22.227:5651/api/exe_aql";
// const form_ip = "http://192.168.22.227:5651/form?form_id=";
// local
// // const BASE_URL = "http://127.0.0.1:8000/api_v1/";
// // const form_url = "http://192.168.22.227:5650/api/exe_aql";
// // const form_ip = "http://192.168.22.227:5650/form?form_id=";

var app_mode ={
	"local":"local",
	"dev":"dev",
	"prod":"prod",
};
// var app_version = "ver 3.16.24 | BEver 3.19.14"; /////
var mode = app_mode.prod; //////

var BASE_URL = "";
var form_url = "";
var form_ip = "";
var BTRT_url = "";

switch (mode) {
	case app_mode.dev:
		BASE_URL = "https://mysuite-backend-dev.lms.solutions/api_v1/";
		form_url = "https://mysuite-form-dev.lms.solutions/api/exe_aql";
		form_ip = "https://mysuite-form-dev.lms.solutions/form?form_id=";
		BTRT_url = "https://hrbtrt-test.lms.solutions/";
		break;

	case app_mode.prod:
		BASE_URL = "https://mysuite-backend.lms.solutions/api_v1/";
		form_url = "https://mysuite-form.lms.solutions/api/exe_aql";
		form_ip = "https://mysuite-form.lms.solutions/form?form_id=";
		BTRT_url = "https://hrbtrt.lms.solutions/";
		break;

	default:
		BASE_URL = "http://127.0.0.1:8000/api_v1/";
		// BASE_URL = "http://10.212.134.200:8000/api_v1/"; // ipconfig => IPv4
		form_url = "http://192.168.22.227:5650/api/exe_aql";
		form_ip = "http://192.168.22.227:5650/form?form_id=";
		BTRT_url = "http://localhost:6001/";
}


const instance = axios.create({
	baseURL: BASE_URL,
	timeout: 0,
	params: {} // do not remove this, its added to add params later in the config
})

instance.interceptors.request.use(function (config) {
	const token = auth.getToken();
	// const PageID = common.App.get_pageID(); // OWK for page auth comm used
	const PageUUID = common.App.get_pageUUID(); // OWK for page auth comm used

	if (token) {
		config.headers.common['Authorization'] = token;
		// config.headers.common['PageID'] = PageID; // OWK for page auth comm used
		config.headers.common['PageUUID'] = PageUUID; // OWK for page auth comm used
	}

	// else {
	// 	config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
	// }

	return config
}, function (error) {
	return Promise.reject(error)
})

instance.interceptors.response.use((response) => response, (error) => {
	//console.log(error.config)
	return Promise.reject(error)
})

export default {
	getData(action) {
		let url = `${BASE_URL}`
		url += action
		return instance.get(url)
	},
	"form_ip": form_ip,
	// "app_version": app_version,
	"BASE_URL": BASE_URL,
	"BTRT_url": BTRT_url,
	"MODE": mode,
	postMsg(action, data) {
		let url = `${BASE_URL}`
		url += action
		return instance.post(url, data)
	},
	putMsg(action, data) {
		let url = `${BASE_URL}`
		url += action
		return instance.put(url, data)
	},
	deleteMsg(action, data) {
		let url = `${BASE_URL}`
		url += action
		return instance.delete(url, {params:data})
	},
	async getFormData(query){
		return await axios.post(form_url,{q:query});
	},
	login(action, data) {
		let url = `${BASE_URL}`
		url += action
		return instance.post(url, data)
	}
}